/**
 * dates.ts — AUDIT-2. Orbit stores days as Postgres `date` columns
 * (projects.due_date, projects.scheduled_date, inquiries.project_date,
 * milestones.due_date, tasks.due_date, galleries.project_date). They
 * arrive as `YYYY-MM-DD`, and `new Date('2026-10-05')` is UTC midnight,
 * which is the EVENING OF THE 4TH in Utah. Every "due Oct 4" that was
 * really due Oct 5 came from that one line.
 *
 * `parseDay` reads a day as a local day (noon, so DST can't nudge it
 * across midnight either way) and leaves real timestamps alone.
 */
const DAY_RE = /^(\d{4})-(\d{2})-(\d{2})$/;

/** A `YYYY-MM-DD` as a local Date at noon; anything else as `new Date(v)`. */
export function parseDay(v: string | Date | null | undefined): Date | null {
  if (v == null || v === '') return null;
  if (v instanceof Date) return v;
  const m = DAY_RE.exec(v);
  if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]), 12);
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** parseDay, but never null — for call sites that already checked. */
export function asDay(v: string | Date): Date {
  return parseDay(v) ?? new Date(NaN);
}
